export default class PlusTime {
    static fromData(data) {
        if (!data) {
            return;
        }

        let plusTime = new PlusTime();
        plusTime.day = data.day;
        plusTime.formattedDay = data.formatted_day;
        plusTime.weekday = data.weekday;
        plusTime.timeRange = data.time_range;
        plusTime.duration = data.duration;
        plusTime.comments = data.comments;
        plusTime.hint = data.hint;

        return plusTime;
    }
}
